import React, {useEffect, useState} from 'react';
import './scss/collection-add.scss';
import CollectionAddProp from './properties/collection-add';
import FullScreenLoader from './full-screen';
import SandraJsAPI from "../services/sandraJsAPI";

function CollectionAdd({setStatusMessage}: CollectionAddProp): React.ReactElement {
    const [name, setName] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [desc, setDesc] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorClass, setSetErrorClass] = useState('hide');

    function validateForm(): boolean {
        if (!name || (name && name.trim().length === 0)) {
            setErrorMessage('Please enter name value');
            setSetErrorClass('error mb-4');
            return false;
        }

        if (!imageUrl || (imageUrl && imageUrl.trim().length === 0)) {
            setErrorMessage('Please enter imageUrl value');
            setSetErrorClass('error mb-4');
            return false;
        }

        setErrorMessage('');
        setSetErrorClass('hide');
        return true;
    }

    function resetForm() {
        setDesc('');
        setName('');
        setImageUrl('');
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();
        if (validateForm()) {
            setIsLoading(true);
            SandraJsAPI.addCollection({
                collectionId: name.toLowerCase().trim().replace(/[^a-zA-Z ]/g, '')
                    .replaceAll(' ', '_'),
                name: name.trim(),
                imageUrl,
                description: desc,
                image: '',
                creationTimestamp: new Date(),
            })
                .then((res) => {
                    console.log(res);
                    setStatusMessage('Collection added successfully', 'success');
                    window.scrollTo(0, 0);
                    setIsLoading(false);
                    resetForm();
                })
                .catch((reason) => {
                    setStatusMessage(reason, 'error');
                    window.scrollTo(0, 0);
                    setIsLoading(false);
                });
        } else {
            window.scrollTo(0, 0);
        }
    };

    useEffect(() => {
    }, []);

    return (
        <div className="rounded collection-add mb-5 loading-wrapper">
            {isLoading ? <FullScreenLoader/> : <div/>}
            <h4 className="pb-3">Add New Collection</h4>
            <form onSubmit={handleSubmit}>
                <div className={errorClass}>{errorMessage}</div>
                <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                        Name
                        <input
                            type="text"
                            id="name"
                            className="form-control"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </label>
                </div>
                <div className="mb-3">
                    <label htmlFor="imageUrl" className="form-label">
                        Image Url
                        <input
                            type="text"
                            id="imageUrl"
                            className="form-control"
                            value={imageUrl}
                            onChange={(e) => setImageUrl(e.target.value)}
                        />
                    </label>
                </div>
                <div className="mb-3">
                    <label htmlFor="desc" className="form-label">
                        Description
                        <textarea
                            id="desc"
                            className="form-control"
                            value={desc}
                            onChange={(e) => setDesc(e.target.value)}
                        />
                    </label>
                </div>
                <button type="submit" className="btn btn-dark">Submit</button>
            </form>
        </div>
    );
}

export default CollectionAdd;
